const FormFieldError= ({error}) => error?.map((val, index)=><h4 key={index} style={{ color: "#842029", fontSize: "14px", fontWeight: 500}}>{val}</h4> ) 
export default FormFieldError
